<template>
<vue-apex-charts type="bar" height="387" :options="lineChartClass.chartOptions" :series="lineChartClass.series" :key="showadata"></vue-apex-charts>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
    components: {
        VueApexCharts
    },
    data() {
        return {
            showadata: 0,
            themeColors: ["#cee4e6", "#c3cad0", "#FFD700","#C0C0C0",  "#614e1a", "#c5473b", "#b36700"],
            lineChartClass: {
                series: [{
                    name: "DIAMANT",
                    data: []
                }, {
                    name: "PLATINUM",
                    data: []
                }, {
                    name: "GOLD",
                    data: []
                }, {
                    name: "SILVER",
                    data: []
                }, {
                    name: "BRONZE ",
                    data: []
                }, {
                    name: "EXPRESS",
                    data: []
                }, {
                    name: "DORMANT ",
                    data: []
                }, ],
                chartOptions: {
                    chart: {
                        height: 350,
                        zoom: {
                            enabled: false
                        }
                    },
                    colors: ['#B9F2FF',"#E5E4E2",'#FFD700','#28C76F','#7367F0','#1D88E5','#EA5455','#FF9F43','#E5E4E2','#B9F2FF'],
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    grid: {
                        row: {
                            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                            opacity: 0.5
                        },
                    },
                    xaxis: {
                        categories: ["JANV",
                            "FÉVR",
                            "MARS",
                            "AVRI",
                            "MAI ",
                            "JUIN",
                            "JUIL",
                            "AOÛT",
                            "SEPT",
                            "OCTO",
                            "NOVE",
                            "DÉCE"
                        ],
                    },
                    yaxis: {
                        title: {
                            text: 'Classe '
                        }
                    },
                    fill: {
                        opacity: 1

                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return val + 'DT';
                            }
                        }

                    }
                }
            }
        }
    },
    methods: {

        getData() {

            // ['#B9F2FF', '#E5E4E2', '#FFD700', '#C0C0C0', '#cd7f32', '#ea00F', '#ea5455'] 
            let d = new Date().getFullYear();
            for (i = 0; i < 12; i++) {
                this.lineChartClass.series[0].data.push(0)
                this.lineChartClass.series[1].data.push(0)
            }
            let localData = JSON.parse(JSON.stringify(this.$store.state.article.analytcsdata.listData.filter(el => {
                return el.Date.substring(0, 4) == d
            })));

            let i = 0;

            for (i = 0; i < localData.length; i++) {

                switch (localData[i].Class) {
                    case 'DIAMANT':
                        this.lineChartClass.series[0].data[i] = localData[i].Amount
                        break;
                    case 'PLATINUM':
                        this.lineChartClass.series[1].data[i] = localData[i].Amount
                        break;
                    case 'GOLD':
                        this.lineChartClass.series[2].data[i] = localData[i].Amount
                        break;
                    case 'SILVER':
                        this.lineChartClass.series[3].data[i] = localData[i].Amount
                        break;
                    case 'BRONZE':
                        this.lineChartClass.series[4].data[i] = localData[i].Amount
                        break;
                    case 'EXPRESS':
                        this.lineChartClass.series[5].data[i] = localData[i].Amount
                        break;
                    case 'DORMANT':
                        this.lineChartClass.series[6].data[i] = localData[i].Amount
                        break;
                    default:
                        this.lineChartClass.series[6].data[i] = localData[i].Amount
                }
            }
            this.showadata++;
        }
    },
    mounted() {
        this.showadata++;
        if (this.$store.state.article.analytcsdata.listData.length > 0) {
            this.getData();

        } else

            this.$store.subscribe(mutation => {
                if (mutation.type === "article/UPDATE_ANALTCS_DATA") {
                    this.getData();

                }
            });
    }
}
</script>
